const getFilteredCategoryItemsNumber = (filteredCategoryItems) =>
  filteredCategoryItems.map(({ categoryItems }) => categoryItems).flat(1).length;

export default getFilteredCategoryItemsNumber;
